import getItemAddresses from './get_item_addresses';
import { typeGroupForContentType } from './conversation_item_type_groups';

/**
 * Decides whether a loaded conversation item should be shown given the active
 * timeline filter. Callers must only invoke this for items whose content has
 * loaded — items that haven't loaded yet are kept as placeholders so that
 * scroll-driven loading continues, and are re-evaluated once their content
 * arrives.
 *
 * @param {Immutable.Map} itemImmutable a loaded conversation item
 * @param {ConversationHistoryFilter} filter the active filter
 * @returns {boolean}
 */
export default function itemPassesFilter(itemImmutable, filter) {
  if (!filter || !filter.isActive()) {
    return true;
  }

  const content = itemImmutable.get('content');
  const contentType = content && content.get('type');

  const groupKey = typeGroupForContentType(contentType);
  if (groupKey && filter.isTypeGroupHidden(groupKey)) {
    return false;
  }

  if (filter.address) {
    return getItemAddresses(itemImmutable).includes(filter.address);
  }

  return true;
}
